import {BaseModel, DisableModel} from 'model/base.model';

export interface Spec extends BaseModel, DisableModel {
    
}

export const defaultSpec: Readonly<Spec> = {
};
